import PropType from 'prop-types'
import React from 'react'
import NumberFormat from 'react-number-format'

function PhoneFormat(props) {
  const { phone } = props

  return (
    <NumberFormat
      value={phone}
      displayType="text"
      format="(##) # #### ####"
      renderText={value => {
        return value
      }}
    />
  )
}

PhoneFormat.propTypes = {
  phone: PropType.string.isRequired
}

export default PhoneFormat
